import React from 'react';
import { getTime } from '@cian/utils';

import { formatDate, formatDateToDDMMYYYY } from '../../../../utils';
import * as s from './DatePublished.css';

interface IDateTimePublished {
  /** Дата строкой вв ISO */
  children: string;
  /** Выводить ли текст Обновлено */
  isUpdated?: boolean;
}

/**
 * Дата и время публикации
 */
export const DateTimePublished = ({ children, isUpdated }: IDateTimePublished) => {
  const date = new Date(children);
  const time = getTime(new Date(children));

  return (
    <time className={s['wrapper']} dateTime={date.toISOString()} title={`${formatDate(date)}, ${time}`}>
      {`${isUpdated ? 'Обновлено ' : ''}${formatDateToDDMMYYYY(date)}, ${time}`}
    </time>
  );
};
